<template>
  <div id="bankruptBid">
    <loading-overlay v-if="isLoading"></loading-overlay>
    <div class="search">
      <el-input
        v-model="form.name"
        placeholder="请输入要查找的案件名称"
        class="nameSearch"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-select v-model="form.status" placeholder="案件状态" class="select">
        <el-option
          v-for="item in Status"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="more"
        ref="choose"
        placeholder="更多筛选"
        class="select"
        @focus="moreSelect()"
      >
      </el-select>
      <el-button type="warning" @click="SearchBid">搜索</el-button>
    </div>
    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column prop="title" label="项目名称" width="160">
        </el-table-column>
        <el-table-column prop="code" label="项目编号"> </el-table-column>
        <el-table-column prop="type" label="项目类型"> </el-table-column>
        <el-table-column prop="lawyer" label="服务律师" width="160">
          <template slot-scope="scope">
            {{ arrToString(scope.row.lawyer) }}
          </template>
        </el-table-column>
        <el-table-column prop="entrustmentTime" label="提交时间" width="160">
          <template slot-scope="scope">
            {{ handleTime(scope.row.entrustmentTime) }}
          </template>
        </el-table-column>
        <el-table-column label="受理状态" prop="casestatus"> </el-table-column>
        <el-table-column label="案件状态" prop="status">
          <template slot-scope="scope">
            <span
              v-if="scope.row.result == 0 && scope.row.status == 0"
              type="text"
              class="casestatus"
              >已通过</span
            >
            <span v-if="scope.row.status == 1" type="text" class="casesresult"
              >待审核</span
            >
            <!-- <span v-if="scope.row.status == 2" type="text" class="casestatus">二次审核中</span> -->
            <span
              v-if="scope.row.result == 1 && scope.row.status == 0"
              type="text"
              class="casesrefuse"
              >未通过</span
            >
            <!-- <span v-if="scope.row.status == 2" type="text" class="casestatus">已结案</span>
                        <span v-if="scope.row.status == 3" type="text" class="casestatus">已归档</span>
                        <span v-if="scope.row.status == -1" type="text" class="casestatus">已删除</span> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="210">
          <template slot-scope="scope">
            <el-button
              class="chakan"
              size="small"
              @click="Look(scope.row.id)"
              v-if="$store.state.rolesname.includes('biddetail')"
              >投标查看</el-button
            >
            <!-- 关联案件是否是草稿案件待补充 -->
            <el-button
              v-if="
                scope.row.seal &&
                (scope.row.bankuptCase == '' ||
                  scope.row.bankuptCase == null) &&
                scope.row.result == 0 &&
                scope.row.status == 0 &&
                $store.state.rolesname.includes('bankinput')
              "
              class="shanchu"
              size="small"
              @click="enter(scope.row.id)"
              >录入案件</el-button
            >
            <el-button
              v-if="
                scope.row.seal &&
                scope.row.bankuptCase != null &&
                $store.state.rolesname.includes('bankdetail')
              "
              class="shanchu"
              size="small"
              @click="bankruptLink(scope.row.bankuptCase.id)"
              >破产查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="bank_pagination">
        <el-pagination
          :hide-on-single-page="value"
          :current-page.sync="PageIndex"
          :page-sizes="PageSizes"
          :page-size="PageSize"
          :pager-count="MaxPage"
          layout="total, sizes, prev, pager, next"
          :total="Total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-if="bPageShow"
        />
      </div>
    </div>

    <!--更多选择!-->
    <el-dialog
      title="搜索"
      :visible.sync="dialogVisible"
      width="45%"
      center
      :show-close="false"
    >
      <el-form ref="form" :model="form" label-width="90px">
        <el-form-item label="案件名称">
          <el-input
            v-model="form.name"
            placeholder="请输入要查找的案件名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="案件类型">
              <el-select
                v-model="form.type"
                placeholder="请选择"
                class="select"
                disabled
              >
                <el-option
                  v-for="item in Casetype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="案件状态">
              <el-select
                v-model="form.status"
                placeholder="请选择"
                class="select"
                clearable
              >
                <el-option
                  v-for="item in Status"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="选择律所">
              <el-select clearable v-model="form.lvsuo" placeholder="请选择">
                <el-option
                  v-for="item in LvSuoList"
                  :key="item.value"
                  :label="item.label"
                  class="select"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="律师">
              <el-input
                v-model="form.lvshi"
                placeholder="请输入"
                class="select"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提交时间">
              <el-date-picker
                class="select"
                value-format="yyyy-MM-dd"
                v-model="form.starttime"
                type="date"
                placeholder="全部-起始"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label-width="10px">
              <el-date-picker
                class="select"
                value-format="yyyy-MM-dd"
                v-model="form.endtime"
                type="date"
                placeholder="全部-终止"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否开发票">
                            <el-select v-model="form.invoice" placeholder="请选择" class="select">
                                <el-option v-for="item in IsorNo" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="是否结案">
                            <el-select v-model="form.closecase" placeholder="请选择" class="select">
                                <el-option v-for="item in IsorNo" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="是否归档">
                            <el-select v-model="form.isorNo" placeholder="请选择" class="select">
                                <el-option v-for="item in IsorNo" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row> -->
        <el-form-item label-width="0"> </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="SearchBid">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>
    
<script>
// import { mapActions } from "vuex";
import { BidSearch } from '../../api/bankrupt'
import { getLvSuo } from '../../api/case'
export default {
  name: 'bankruptBid',
  // components:{
  //   Table
  // },
  data() {
    return {
      LvSuoList: [],
      isLoading: false,
      bPageShow: true,
      next: false, //不是案件页面
      form: {
        name: '',
        status: null,
        starttime: null,
        endtime: null,
        type: '破产案件投标',
        invoice: null,
        closecase: null,
        isorNo: null,
        lvshi: '',
        lvsuo: ''
      },
      more: '',
      Status: [
        { label: '已通过', value: 0 },
        { label: '待审核', value: 1 },
        { label: '未通过', value: 4 }
        // ,{label:"已结案",vaule:2},{label:"已归档",vaule:3}
        // ,{label:"已删除",value:-1}
      ],
      // CaseType:[{ label: "已通过", value: 0 }, { label: "一审", value: 1 }],
      dialogVisible: false, //弹出框
      IsorNo: [
        { label: '是', value: true },
        { label: '否', value: false }
      ],
      Casetype: [],
      tableData: [],
      PageSizes: [10, 20, 50, 100],
      PageIndex: 1,
      PageSize: 10,
      Total: 0,
      MaxPage: 5,
      value: false //只有一页的时候隐藏分页
    }
  },
  mounted() {
    //     this.currentPage=this.$store.state.page
    // this.bPageShow = false;
    // this.$nextTick(()=>{
    //     this.bPageShow = true;
    //   });
    //   this.Search()
  },

  methods: {
    // 获取律所
    GetLvSuo() {
      getLvSuo({})
        .then((res) => {
          this.LvSuoList = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    arrToString(arr) {
      return arr.join(' , ')
    },
    getvalue() {
      //传值给父组件，
      this.$emit('value', this.next)
    },

    bankruptLink(id) {
      this.$router.push({
        path: 'bankruptdetail',
        name: 'bankruptdetail',
        query: { guid: id, type: '破产' }
      })
    },
    enter(id) {
      //录入案件
      let that = this
      that.$router.push({
        path: 'bankinput',
        query: { guid: id }
      })
    },
    moreSelect() {
      //更多选择
      this.$refs.choose.blur()
      this.dialogVisible = true
    },
    SearchBid() {
      //查询按钮
      this.PageIndex = 1
      this.Search()
    },
    Search() {
      //获取数据
      this.isLoading = true
      var starttime = null
      var endtime = null
      if (this.form.starttime) {
        starttime = this.JsonTime(this.form.starttime)
      }
      if (this.form.endtime) {
        endtime = this.JsonTime(this.form.endtime)
      }
      BidSearch({
        page: this.PageIndex,
        rows: this.PageSize,
        Title: this.form.name,
        Status: this.form.status === '' ? null : this.form.status,
        StartTime: starttime,
        EndTime: endtime,
        Invoice: this.form.invoice,
        Closecase: this.form.closecase,
        IsorNo: this.form.isorNo,
        Type: '破产案件投标',
        lvshi: this.form.lvshi,
        IsAll: true
      }).then((res) => {
        // console.log(res)
        if (res.data.status == 'success') {
          this.tableData = res.data.data

          this.Total = res.data.total
          this.dialogVisible = false
        } else if (
          res.data.status == '401' ||
          res.data.status == '402' ||
          res.data.status == '403'
        ) {
          this.$message.error(res.data.message)
          window.sessionStorage.removeItem('token')
          window.sessionStorage.removeItem('hasRoles')
          this.$router.push('/login')
        }
        this.isLoading = false
      })
    },

    Look(id) {
      //查看
      this.$router.push({
        path: 'bankruptdetail',
        name: 'bankruptdetail',
        query: { guid: id, type: '破产投标' }
      })
    },
    del(id) {
      //删除
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.Search()
    },
    handleCurrentChange(val) {
      this.$store.commit('setPage', val)
      this.PageIndex = val
      this.Search()
    },
    reset() {
      //重置更多选择
      this.form.name = ''
      this.form.status = null
      this.form.starttime = null
      this.form.endtime = null
      this.form.invoice = null
      this.form.closecase = null
      this.form.isorNo = null
      this.form.type = '破产案件投标'
      this.form.lvshi = ''
      this.form.lvsuo = ''
    },
    // 时间格式
    handleTime(time) {
      // yyyy-MM-dd HH:MM:SS
      var t = new Date(time).toJSON()
      return new Date(+new Date(t) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')
    },
    JsonTime(date) {
      // yyyy-MM-ddT HH:MM:SS
      var t = new Date(date).getTime()
      var d = new Date(t + 8 * 3600 * 1000).toISOString()
      return d
    },
    updateConditions() {
      const type = 'BidPage'
      if (this.$store.state.searchConditions[type]) {
        this.conditions = this.$store.state.searchConditions[type]
      }
    }
  },
  created() {
    this.getvalue()
    this.GetLvSuo()
    // this.Search();
  },

  beforeRouteLeave(to, from, next) {
    const type = 'BidPage'
    if (to.name == 'bankruptdetail' || to.name == 'bankruptfile') {
      var con = {
        form: this.form,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize
      }
      this.$store.dispatch('saveSearchCondition', { type, condition: con }) //保存
    } else {
      this.$store.dispatch('clearSearchConditions', type) //保存
    }

    next()
  },
  beforeRouteEnter(to, from, next) {
    // 辅助函数，用于在组件实例化之前执行一些代码
    function fetchData() {
      const type = 'BidPage'
      // console.log("获取")
      // 从 Vuex store 中读取搜索条件
      if (this.$store.state.searchConditions[type]) {
        return this.$store.state.searchConditions[type]
      }
      return null
    }
    // 通过 next 回调访问组件实例
    next((vm) => {
      const fetchedData = fetchData.call(vm)
      if (
        fetchedData &&
        (from.name == 'bankruptdetail' || from.name == 'bankruptfile')
      ) {
        vm.form = fetchedData.form
        vm.PageIndex = fetchedData.PageIndex
        vm.PageSize = fetchedData.PageSize
        // console.log(fetchedData.PageIndex)
        vm.bPageShow = false
        vm.$nextTick(() => {
          vm.bPageShow = true
        })
        vm.Search()
      } else {
        vm.Search()
      }
    })
  },

  computed: {
    targetRoutes() {
      let target = this.$store.state.permission.addRoutes.filter(
        (el) => el.path == '/home/bankrupt' //遍历每一个数组，过滤出返回值委true的值
      )
      // console.log(target[0].children)
      let arr = target[0].children.filter((el) => el.hidden != true)
      // console.log(arr)
      return arr
    }
  }
}
</script>
    
<style lang="less" scoped>
.bankrupt {
  width: 98%;
  margin: auto;
  border-radius: 16px;

  .el-menu {
    display: flex;
    text-align: center;
    border-right: 0px;
    // margin-bottom: 5vh;
    // .el-menu-item{
    //   width:20vh;
    // }

    .el-menu-item {
      font-size: 16px;
      height: 55px;

      &:hover {
        background-color: #fff;
        color: #409eff !important;
        border-bottom: 1px solid #409eff;
      }
    }

    .el-menu-item.is-active {
      background-color: #fff !important;
      border-bottom: 1px solid #409eff;
      color: #409eff !important;
    }
  }
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.menu {
  width: 99%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/.el-card__body,
.el-main {
  padding: 0px;
  padding-bottom: 20px;
}

.xian {
  width: 100%;
  border-bottom: 1px solid rgba(238, 239, 242, 1);
  margin-bottom: 24px;
}

// 查询
.search {
  width: 99%;
  margin: auto;
  display: flex;
  padding-left: 20px;
  margin-bottom: 24px;
}

.search ::v-deep .el-input__inner {
  // width: 80% !important;
  // width: 300px;
  background-color: #fafafa;
  border: 0 !important;
  border-radius: 12px;
}

.nameSearch {
  width: 24vw;
  margin-right: 10px;
}

.select {
  width: 10vw;
  margin-right: 10px;
}

// 弹出框
/deep/.el-dialog__header {
  padding: 10px 10px 10px;
  background: rgba(250, 250, 250, 1);
  font-size: 18px;
}

.btn {
  width: 100%;
  text-align: center;
}

//表格
.casestatus {
  color: #2bc887;
}

.casesresult {
  color: #fe964a;
}

.casesrefuse {
  color: #df0d0d;
}

.chakan {
  background: #e7f7ef;
  border-radius: 8px;
  color: #0caf60;
  border: none;
}

.shanchu {
  background: #fff0e6;
  border-radius: 8px;
  color: #fe964a;
  border: none;
}

.ma {
  background: #eff5ff;
  border-radius: 8px;
  color: #3077e6;
  border: none;
}

// 分页

.bank_pagination {
  text-align: right;
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

/deep/.el-pagination__total {
  float: left;
}

/deep/.el-pagination__sizes {
  float: left;
}
</style>
    